module.exports = __webpack_public_path__ + "static/Kaizen_Corp_Programa-5fbeb755663a9c6db0c5cff12458eede.png";